import React from "react";
import "./deleteaccount.css";

const DeleteAccount = () => {
  return (
    <section className="tc-container">

      <div className="tc-header">
        <h1>Delete Account – RoomBuddy</h1>
        <p>RoomBuddy Account Deletion Request</p>
      </div>

      <div className="tc-content">

        <h2>1. How to Request Account Deletion</h2>
        <p>
          If you would like to delete your RoomBuddy account and associated data,
          please follow the steps below:
        </p>

        <p>
          • Send an email to <strong>support@roombuddy.in</strong><br />
          • Use the subject line: <strong>Account Deletion Request</strong><br />
          • Mention your registered mobile number or email ID used in the app.
        </p>

        <p>
          Our team will verify your request and process the deletion within
          <strong> 7 working days</strong>.
        </p>

        <h2>2. What Data Will Be Deleted</h2>
        <p>
          When your account is deleted, the following data will be permanently removed:
        </p>

        <p>
          • Profile information (name, phone number, email)<br />
          • Property listings<br />
          • Uploaded images<br />
          • Account login details<br />
          • Associated usage data
        </p>

        <h2>3. Data Retention</h2>
        <p>
          Certain data may be retained for legal compliance, fraud prevention,
          tax or regulatory requirements.
        </p>

        <p>
          This retained data will not be used for marketing purposes.
        </p>

        <h2>4. Contact Us</h2>

        <div className="tc-highlight">
          For any questions, contact:<br />
          📧 <strong>support@roombuddy.in</strong><br />
          🌐 <strong>www.roomsbuddy.com</strong>
        </div>

      </div>

    </section>
  );
};

export default DeleteAccount;
